import ActivityReason from './ActivityReason'
import Employee from './Employee'
export class SaveActivityReasonRequest {
    ActivityReason: ActivityReason;
    SavedByEmployee: Employee;
}

export default SaveActivityReasonRequest;